/**
 * Google Analytics 4 - Tracking de eventos
 */

import ReactGA from 'react-ga4';

// Inicializar GA4
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (measurementId) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    });
    console.log('✅ Google Analytics inicializado');
  }
};

// Trackear pageview
export const trackPageView = (path) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Eventos personalizados
export const trackEvent = (category, action, label = '', value = 0) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Eventos específicos del negocio
export const analytics = {
  // Usuario se registra
  signUp: (method = 'email') => {
    trackEvent('User', 'Sign Up', method);
    ReactGA.event('sign_up', { method });
  },

  // Usuario inicia sesión
  login: (method = 'email') => {
    trackEvent('User', 'Login', method);
    ReactGA.event('login', { method });
  },

  // Usuario inicia trial
  startTrial: (plan) => {
    trackEvent('Subscription', 'Start Trial', plan);
    ReactGA.event('trial_start', { plan });
  },

  // Usuario se suscribe (conversión)
  purchase: (plan, value) => {
    trackEvent('Subscription', 'Purchase', plan, value);
    ReactGA.event('purchase', {
      currency: 'USD',
      value: value,
      items: [
        {
          item_id: plan.toLowerCase(),
          item_name: `Genia+ ${plan}`,
          price: value,
        },
      ],
    });
  },

  // Usuario cancela suscripción
  cancelSubscription: (plan, reason = '') => {
    trackEvent('Subscription', 'Cancel', plan);
    ReactGA.event('subscription_cancel', { plan, reason });
  },

  // Usuario conecta credenciales Amazon
  connectAmazon: (type) => {
    trackEvent('Integration', 'Connect Amazon', type);
    ReactGA.event('connect_amazon', { type });
  },

  // Usuario sincroniza productos
  syncProducts: (count) => {
    trackEvent('Sync', 'Products', '', count);
    ReactGA.event('sync_products', { count });
  },

  // Usuario usa AI Chat
  useAIChat: (messageCount) => {
    trackEvent('Feature', 'AI Chat', '', messageCount);
    ReactGA.event('use_ai_chat', { message_count: messageCount });
  },

  // Usuario usa Calculator
  useCalculator: () => {
    trackEvent('Feature', 'Calculator');
    ReactGA.event('use_calculator');
  },

  // Usuario ve Profit Tracker
  viewProfitTracker: () => {
    trackEvent('Feature', 'Profit Tracker');
    ReactGA.event('view_profit_tracker');
  },

  // Usuario hace upgrade de plan
  upgradePlan: (fromPlan, toPlan) => {
    trackEvent('Subscription', 'Upgrade', `${fromPlan} → ${toPlan}`);
    ReactGA.event('upgrade_plan', { from_plan: fromPlan, to_plan: toPlan });
  },

  // Error crítico
  error: (errorMessage, errorLocation) => {
    trackEvent('Error', errorMessage, errorLocation);
    ReactGA.event('exception', {
      description: errorMessage,
      fatal: false,
    });
  },
};

export default analytics;
